/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Max_Players_DescInputs */



/**
* | output |
* | --- |
* | "venue capacity — sign-ups past it land on the waitlist, never refused" |
*
* @param {Og_Cfg_Max_Players_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_max_players_desc = /** @type {((inputs?: Og_Cfg_Max_Players_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Max_Players_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("capacité du lieu — les inscriptions au-delà rejoignent la liste d'attente, jamais refusées")
	if (locale === "es") return /** @type {LocalizedString} */ ("capacidad de la sede — las inscripciones que lo superen pasan a la lista de espera, nunca se rechazan")
	if (locale === "pt") return /** @type {LocalizedString} */ ("capacidade do local — inscrições além dele vão para a lista de espera, nunca recusadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("capacità della sede — le iscrizioni oltre il tetto entrano nella lista d'attesa, mai rifiutate")
	return /** @type {LocalizedString} */ ("venue capacity — sign-ups past it land on the waitlist, never refused")
});